var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMpvDefault = function SvgMpvDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M13.204 14.751a1.222 1.222 0 1 1-2.445 0 1.222 1.222 0 0 1 2.445 0ZM37.438 14.751a1.222 1.222 0 1 1-2.444 0 1.222 1.222 0 0 1 2.444 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M23.707 3.425h-.041a.4.4 0 0 0-.351.595l1.565 2.678a.77.77 0 0 0 .668.384c1.928 0 4.164 0 6.056.004.364 0 .523-.454.231-.673-3.908-2.934-6.247-2.964-8.128-2.988ZM13.666 3.753l-.225 2.62a.78.78 0 0 1-.78.71 74 74 0 0 0-3.303.062c-.588.024-.983-.59-.753-1.13.272-.639.55-1.311.875-1.81a.65.65 0 0 1 .393-.274c.804-.197 2.21-.404 3.562-.428a.23.23 0 0 1 .231.25ZM21.213 3.472c-1.358-.09-4.232-.243-5.604-.075-.318.04-.53.315-.544.634l-.122 2.651c-.01.22.166.405.387.405l7.6-.004c.293 0 .48-.314.34-.572l-1.433-2.638a.77.77 0 0 0-.624-.401Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m9.002 15-2.946-1.171a.4.4 0 0 1-.225-.238l-.17-.502a2.87 2.87 0 0 1 .39-2.599v0a.3.3 0 0 0 .054-.167V7.419a.8.8 0 0 1 .06-.3c.473-1.132.915-2.276 2.203-4.122a.74.74 0 0 1 .474-.307c4.928-.91 14.569-.928 19.213.034a.7.7 0 0 1 .213.08c2.391 1.345 4.403 2.785 6.28 3.74q.124.063.262.08c.733.086 4.273.557 7.566 1.87.096.039.177.101.214.197.241.636.82 3.243-.276 5.284a.7.7 0 0 1-.51.353l-2.445.423m-24.286 0h18.214"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M14.84 14.751a2.857 2.857 0 1 1-5.715 0 2.857 2.857 0 0 1 5.715 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.215,
    cy: 14.751,
    r: 2.857,
    stroke: "#1E242F",
    strokeWidth: 0.774
  })));
};
export default SvgMpvDefault;